// @flow
import React from 'react';
import { withTheme } from 'styled-components';
import { Jumbo } from '@finect/tabular-components/Jumbo';
import { Section } from '@finect/tabular-components/Section';
import JumboIndexedFundsImg from './../../../assets/jumbo-indexed-funds.jpg';
import JumboIndexedFundsPhoneImg from './../../../assets/jumbo-indexed-funds-phone.jpg';

export const PlatformsStorefrontJumboSmall = ({
  theme,
  margin = 'top',
  utmMedium = 'Banner_Escaparate',
  utmContent
}: {
  theme: Object,
  margin: 'top' | 'bottom' | null,
  utmMedium?: string,
  utmContent?: string
}) => (
  <Section {...(margin === 'top' ? { topMargin: true } : margin === 'bottom' ? { bottomMargin: true } : {})}>
    <Jumbo
      id="storefront-platforms-indexed-funds"
      variant="small"
      textAlign="left"
      coverImage={JumboIndexedFundsImg}
      coverImagePhone={JumboIndexedFundsPhoneImg}
      color="#fff"
      backgroundColor={theme.colors.primaryM}
      title="Mejores plataformas para invertir en fondos indexados"
      cta="¡Descúbrelas ahora!"
      ctaVariant="secondary"
      link={`https://www.finect.com/usuario/avillanuevae/articulos/mejores-plataformas-invertir-fondos-indexados?utm_source=Finect&utm_medium=${utmMedium}&utm_campaign=Plataformas${
        utmContent ? `&utm_content=${utmContent}` : ''
      }`}
    />
  </Section>
);

export default withTheme(PlatformsStorefrontJumboSmall);
